export default {
  text: 'Apri profilo {{paymentGateway}}',
  text_generic: 'Apri profilo di onboarding',
  toasts: {
    failed_to_create: 'Impossibile aprire il profilo {{paymentGateway}}',
    link_copied: 'Link copiato negli appunti',
    copy_failed: 'Impossibile copiare il link',
  },
};
